import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./components/Auth/AuthProvider";
import installSubmitGuard from "./utils/submitGuard";

installSubmitGuard();


const accessToken = sessionStorage.getItem("permissiontoken");

ReactDOM.render(

  <App />,

  document.getElementById("root")
);

reportWebVitals();
